export const skillsList = "SKILLS_LIST";